import React from "react";
import HeaderOpenData from "./HeaderOpenData";
import FooterOpenData from "./FooterOpenData";
import ListDataKategoriDataOpenData from "./kategori/ListDataKategoriDataOpenData";

const PagesKategoriDataOpenData = ({formatDate})=>{
    
    return(
        <div>
            <HeaderOpenData />
            <ListDataKategoriDataOpenData formatDate={formatDate} />
            <FooterOpenData />
        </div>
    )
}

export default PagesKategoriDataOpenData;